import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts")({
  head: () => pageHead({ title: 'RV Parts & Accessories', description: 'Shop RV parts and accessories at Rex & Sons RVs. Thousands of products in stock.', path: '/parts' }),
  beforeLoad: () => {
    throw redirect({ href: "/rv-parts" });
  },
});
